import React from "react";

import { useSelector } from "react-redux";

interface BreadCrumbProps {
  pageName?: string;
}

export const BreadCrumb = (props: BreadCrumbProps) => {
  const activeTopNavigationElement = useSelector(
    (state: any) => state.sideNavigation.activeParent
  );

  let elements = [{ name: "DOMIK" }, { name: activeTopNavigationElement }];

  if (props.pageName) {
    elements.push({ name: props.pageName });
  }

  let elementLength = elements.length;

  return (
    <h4 className="mb-2 mb-sm-0 pt-1">
      {elements.map((element: any, index) => {
        let contentForElement: any[] = [];
        contentForElement.push(
          <a href="#" target="_blank">
            {element.name}
          </a>
        );

        if (index + 1 < elementLength) {
          contentForElement.push(<span> / </span>);
        }

        return contentForElement;
      })}
    </h4>
  );
};
